






import { Component, Vue } from 'vue-property-decorator'
import { InitModule } from '@/store/modules/init'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'App'
})
export default class extends Vue {
  created() {
    if (UserModule.token) {
      InitModule.GetShopList()
      InitModule.GetWarehouseList()
    }
  }
}
